import { Link } from 'react-router-dom'

export function SmsExamplePage() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="max-w-2xl mx-auto px-6 py-10 space-y-6">

        {/* Header */}
        <div className="border-b border-gray-200 dark:border-gray-700 pb-6">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Text Message Opt In / Opt Out</h1>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">Relay Tracker · Reno Tahoe Odyssey</p>
        </div>

        {/* Image */}
        <div>
          <img
            src="/VanExchangeAlert3.jpg"
            alt="Example of Van Exchange Alert text message opt in and opt out"
            className="rounded-lg w-full shadow-md"
          />
        </div>

        {/* Back link */}
        <div className="border-t border-gray-200 dark:border-gray-700 pt-6">
          <Link to="/login" className="text-sm text-blue-600 hover:underline flex items-center gap-1">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
            </svg>
            Back to Login
          </Link>
        </div>

      </div>
    </div>
  )
}
